function capitalize(value: string): string {
	return value.charAt(0).toUpperCase() + value.slice(1)
}

export function generateNameFromEmail(email: string): string {
	const [preAt] = email.split("@")
	if (!preAt) return email

	const separators = [".", "-", "_"]
	for (const sep of separators) {
		if (preAt.includes(sep)) {
			return preAt.split(sep).map(capitalize).join(" ")
		}
	}
	return capitalize(preAt)
}

// Some OAuth providers return the email as the display name. Fall back to an
// email-derived name so a member is never stored with their raw email as name.
export function resolveDisplayName(
	name: string | null | undefined,
	email: string,
): string {
	const trimmed = name?.trim()
	if (trimmed && !trimmed.includes("@")) return trimmed
	return generateNameFromEmail(email)
}
